import React from "react";
import styled from "styled-components";
import { unstyledButton } from "shared/styles/CommonStyles";

interface Props {
  buttonId?: string;
  badgeId?: string;
  className?: string;
  count: number | string;
  iconText: "😄" | "👍";
  onClick?: () => void;
}

const UserReactionIconButton: React.FC<Props> = ({
  buttonId,
  badgeId,
  count = 0,
  onClick,
  className,
  iconText,
}) => {
  return (
    <IconButton id={buttonId} onClick={onClick} className={className}>
      {iconText}
      <CountBadge id={badgeId}>{count}</CountBadge>
    </IconButton>
  );
};

const IconButton = styled.button`
  ${unstyledButton};
  background-color: var(--body-bg-clr);
  border-radius: 10px;
  font-size: 20px;
  height: 58px;
  line-height: 20px;
  padding: 8px;
  position: relative;
  width: 50px;

  &.isClicked,
  &:hover {
    background-color: var(--box-bdr-clr);

    & > span {
      text-decoration: underline;
    }
  }
`;

const CountBadge = styled.span`
  color: var(--cap-clr);
  display: block;
  font-size: 14px;
  line-height: 14px;
  margin-top: 6px;
`;

export default UserReactionIconButton;
